module.exports = __webpack_public_path__ + "static/media/logo_ltm_bg_dark.dfa0488e.svg";